// ============================================
// Bóc danh sách khỏi payload của API — DÙNG CHUNG.
//
// api-client có interceptor tự bóc envelope (packages/api-client/src/client.ts):
//   { meta, data: [...] }  -> { count, next, previous, results: [...] }
//   { code, message, data } -> data          <-- trường hợp này ra MẢNG TRẦN
// Nghĩa là cùng một endpoint, tuỳ BE có trả `meta` hay không, FE nhận về
// { results: [...] } hoặc [...]. Màn nào chỉ đọc `.results` sẽ thấy rỗng và hiển
// thị "không có dữ liệu" dù API trả đủ (bug #75 ở Reports, bug #5 ở tìm kiếm).
//
// Mọi chỗ đọc danh sách từ API PHẢI đi qua đây.
// ============================================

type ListEnvelope<T> = {
  results?: T[];
  items?: T[];
  products?: T[];
  data?: T[] | { results?: T[]; items?: T[]; data?: T[]; products?: T[]; count?: number };
  count?: number;
  total?: number;
  meta?: { count?: number };
};

/** Trả về mảng record từ mọi hình dạng payload đã biết; không khớp thì trả mảng rỗng. */
export function extractList<T>(payload: unknown): T[] {
  if (Array.isArray(payload)) return payload as T[];

  const data = payload as ListEnvelope<T> | undefined;
  if (!data || typeof data !== 'object') return [];

  if (Array.isArray(data.data)) return data.data;
  if (data.data && typeof data.data === 'object') {
    return data.data.data ?? data.data.results ?? data.data.items ?? data.data.products ?? [];
  }

  return data.results ?? data.items ?? data.products ?? [];
}

/** Tổng số record theo server; không có thì dùng `fallback` (thường là độ dài trang hiện tại). */
export function extractCount<T>(payload: unknown, fallback: number): number {
  if (Array.isArray(payload)) return payload.length;

  const data = payload as ListEnvelope<T> | undefined;
  if (!data || typeof data !== 'object') return fallback;

  if (data.data && typeof data.data === 'object' && !Array.isArray(data.data)) {
    return data.data.count ?? data.count ?? data.total ?? data.meta?.count ?? fallback;
  }

  return data.count ?? data.total ?? data.meta?.count ?? fallback;
}
